import { MainLayoutContent } from "components/layouts/MainLayoutContent";
import { AppRouteType } from "navigation/registryRoutes";
import slugs from "navigation/slugs";

import React from 'react';
const ReferralShare = React.lazy(() => import("../page/index"));

const routes: AppRouteType[] = [
  {
    path: slugs.referralShare,
    component: ReferralShare,
    container: MainLayoutContent,
    isAuthNeeded: true,
  },
];

export default routes;
